<template>
  <div class="single-color-gen">
    <div class="scg-toolbar">
      <span class="scg-toolbar-title">宣传图生成</span>
      <button class="scg-generate-all-btn" @click="generateAll" :disabled="!hasAnyReady">
        全部生成
      </button>
      <button
        class="scg-fission-all-btn"
        @click="goFission"
      >用于裂变</button>
      <button class="scg-download-page-btn" @click="downloadPageImages">下载全页图片</button>
      <button class="clear-task-btn" @click="onClearTask">清空任务</button>
    </div>

    <div v-for="(product, pi) in workbench.products" :key="product.id" class="scg-product-section">
      <div class="scg-product-header">
        <span class="scg-product-name">{{ product.name }}</span>

        <div class="scg-select-all" @click="workbench.selectAllSlots(pi)">
          <svg v-if="workbench.isAllSlotsSelected(pi)" viewBox="0 0 24 24" fill="#d98a52" width="16" height="16">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="none" stroke="#c9cdd4" stroke-width="2" width="16" height="16">
            <rect x="3" y="3" width="18" height="18" rx="3"/>
          </svg>
          <span>全选</span>
        </div>

        <div class="scg-mode-select">
          <button
            class="scg-mode-btn"
            :class="{ active: workbench.imageGen.modes[pi] === 'simple' }"
            @click="workbench.setProductMode(pi, workbench.imageGen.modes[pi] === 'simple' ? '' : 'simple')"
          >简约背景</button>
          <button
            class="scg-mode-btn"
            :class="{ active: workbench.imageGen.modes[pi] === 'lifestyle' }"
            @click="workbench.setProductMode(pi, workbench.imageGen.modes[pi] === 'lifestyle' ? '' : 'lifestyle')"
          >生活场景</button>
        </div>

        <div class="scg-count-control">
          <button @click="workbench.setGenCount(pi, workbench.imageGen.genCounts[pi] - 1)" :disabled="workbench.imageGen.genCounts[pi] <= 1">-</button>
          <span>{{ workbench.imageGen.genCounts[pi] }} 张</span>
          <button @click="workbench.setGenCount(pi, workbench.imageGen.genCounts[pi] + 1)" :disabled="workbench.imageGen.genCounts[pi] >= 6">+</button>
        </div>

        <button class="scg-gen-btn" @click="generateProduct(pi)" :disabled="!canGenerate(pi)">
          {{ genBtnText(pi) }}
        </button>
        <button
          class="scg-download-zip-btn"
          :disabled="!hasAnyPromoImage(pi)"
          @click="downloadZip(pi)"
        >下载全部</button>
        <button class="clear-product-btn" @click="workbench.clearImageGenProduct(pi)">清空</button>
      </div>

      <div class="scg-results-grid">
        <div
          v-for="(slot, si) in (workbench.imageGen.genResults[pi] || [])"
          :key="si"
          class="scg-result-card"
          :class="{ selected: workbench.isSlotSelected(pi, si) }"
          :style="{ aspectRatio: '1/1' }"
        >
          <template v-if="slot.loading">
            <div class="scg-loading-ring">
              <svg viewBox="0 0 36 36">
                <circle class="ring-bg" cx="18" cy="18" r="16" fill="none" stroke="#e5e6eb" stroke-width="3"/>
                <circle class="ring-fg" cx="18" cy="18" r="16" fill="none" stroke="#d98a52" stroke-width="3"
                  :stroke-dasharray="100" :stroke-dashoffset="100 - slot.progress" stroke-linecap="round"
                  transform="rotate(-90 18 18)"/>
              </svg>
              <span class="ring-text">{{ Math.round(slot.progress) }}%</span>
            </div>
          </template>
          <template v-else-if="slot.url">
            <div v-if="slot.error" class="scg-slot-error scg-retry-error" role="alert">
              {{ slot.error }} 当前保留上一次的图片。
            </div>
            <img :src="slot.url" class="scg-result-img" @click="openPromoLightbox(pi, slot.url)" />
            <div class="scg-select-check" @click.stop="workbench.toggleSlotSelection(pi, si)">
              <svg v-if="workbench.isSlotSelected(pi, si)" viewBox="0 0 24 24" fill="#d98a52" width="18" height="18">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" width="18" height="18">
                <rect x="3" y="3" width="18" height="18" rx="3"/>
              </svg>
            </div>
            <div class="scg-result-actions">
              <button class="scg-action-btn" title="裁剪" @click.stop="startCrop(pi, si)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"/>
                  <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"/>
                </svg>
              </button>
              <button class="scg-action-btn" title="重新生成" @click="workbench.generateOneImageSlot(pi, si)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <polyline points="23 4 23 10 17 10"/>
                  <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                </svg>
              </button>
              <button class="scg-action-btn" title="下载" @click="downloadImage(slot.url, `${product.name}-${si + 1}.png`)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="7 10 12 15 17 10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
              </button>
              <button class="scg-action-btn delete" title="删除" @click="workbench.clearImageSlot(pi, si)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                </svg>
              </button>
            </div>
          </template>
          <template v-else>
            <div class="scg-empty-slot" @click="workbench.generateOneImageSlot(pi, si)" :class="{ clickable: canGenerate(pi) }">
              <template v-if="slot.error">
                <div class="scg-slot-error">{{ slot.error }}</div>
              </template>
              <template v-else>
                <svg viewBox="0 0 24 24" fill="none" stroke="#c9cdd4" stroke-width="1.5" width="24" height="24">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <ImageCropper
      :visible="cropState.visible"
      :imageSrc="cropState.imageSrc"
      @confirm="onCropConfirm"
      @cancel="onCropCancel"
      @restore="onCropRestore"
    />
  </div>
</template>

<script setup>
import { computed, reactive } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import ImageCropper from '@/components/common/ImageCropper.vue'

// eslint-disable-next-line no-undef
const emit = defineEmits(['fission'])

const workbench = useWorkbenchStore()

const onClearTask = () => {
  if (!confirm('确定要清空当前任务吗？\n\n所有产品（A/B/C）的上传图片和所有生成结果都会被删除，且无法恢复。')) return
  workbench.clearAllTask()
}

const hasAnyReady = computed(() =>
  workbench.products.some((_, i) => workbench.imageGen.modes[i])
)

const selectedCount = computed(() => workbench.selectedFissionSlots.length)

const canGenerate = (pi) => {
  if (!workbench.imageGen.modes[pi]) return false
  return true
}

const genBtnText = (pi) => {
  if (!workbench.imageGen.modes[pi]) return '选择模式'
  return '生成'
}

const generateProduct = (pi) => {
  workbench.generateAllSlots(pi)
}

const generateAll = () => {
  workbench.generateAllProducts()
}

const goFission = () => {
  if (selectedCount.value > 0) {
    workbench.enterFissionFromSelection()
  } else {
    workbench.imageGen.step = 3
  }
  emit('fission')
}

const openPromoLightbox = (pi, url) => {
  const urls = (workbench.imageGen.genResults[pi] || []).filter(s => s.url).map(s => s.url)
  workbench.openLightbox(url, urls)
}

const downloadImage = (url, filename) => {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
}

const hasAnyPromoImage = (pi) => (workbench.imageGen.genResults[pi] || []).some(s => s.url)

const downloadZip = async (pi) => {
  try {
    await workbench.downloadProductZip(pi)
  } catch (e) {
    alert('下载失败: ' + e.message)
  }
}

const downloadPageImages = async () => {
  try {
    await workbench.downloadAllProductsZip()
  } catch (e) {
    alert('下载失败: ' + e.message)
  }
}

const cropState = reactive({ visible: false, imageSrc: '', pi: -1, si: -1 })

const startCrop = (pi, si) => {
  const slot = workbench.imageGen.genResults[pi]?.[si]
  if (!slot?.url) return
  cropState.imageSrc = slot.url
  cropState.pi = pi
  cropState.si = si
  cropState.visible = true
}

const onCropConfirm = (croppedBase64) => {
  workbench.applyCropResult('promo', cropState.pi, cropState.si, croppedBase64)
  cropState.visible = false
}

const onCropRestore = () => {
  workbench.restoreOriginalImage('promo', cropState.pi, cropState.si)
  cropState.visible = false
}

const onCropCancel = () => {
  cropState.visible = false
}
</script>

<style scoped>
.scg-retry-error {
  position: absolute;
  top: 34px;
  left: 6px;
  right: 6px;
  z-index: 3;
  background: #fff4f4;
  border-radius: 6px;
}
/* 勾选图标与进度环统一使用主题主色（模板属性已为焦糖色，此处用变量兜底保持一致） */
.scg-select-all svg[fill="#d98a52"],
.scg-select-check svg[fill="#d98a52"] {
  fill: var(--primary-color);
}
.ring-fg {
  stroke: var(--primary-color);
}
/* 覆写全局 components.css 中的蓝色 hover（scoped 优先级更高） */
.scg-select-all:hover {
  color: var(--primary-active);
}
.scg-empty-slot.clickable:hover {
  background: var(--primary-softer);
  color: var(--primary-active);
}
.scg-empty-slot.clickable:hover svg {
  stroke: var(--primary-color);
}
</style>
